import pubsub from '@viewlift/pubsub'
import React, { useEffect, useState } from 'react'
import Spinner from '../spinner'
import "./style.scss"
import { isKeycloakAuthFlow } from "../../OnBoarding-V2/LoginV2/Helpers/keycloakLogin";

const ModuleLoader = () => {
    const initialLoadingState = isKeycloakAuthFlow() || false;
    const [isLoading, setIsLoading] = useState(initialLoadingState);
  
    useEffect(() => {
      pubsub.subscribe('apploading',(data) => {
        setIsLoading(data)
      })
    }, [])
  return (<>
  <div className='module-loader-wrapper'>
  {isLoading ? <Spinner /> : <></>}
  </div>
  </>)
}

export default ModuleLoader